import { combineReducers } from "@reduxjs/toolkit";
import adminLoginReducer from "./persist/admin-login-slice";
import spinnerReducer from "./spinner"
export const rootReducer = combineReducers({
  adminLoginReducer,
  spinnerReducer
});
